import { render, staticRenderFns } from "./TaxasChecktudo.vue?vue&type=template&id=67dc7108&"
import script from "./TaxasChecktudo.vue?vue&type=script&lang=js&"
export * from "./TaxasChecktudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports